import { ITopMenuDesktop } from '../../interfaces';
import TopMenuDesktopBeforeItem from './before';
import TopMenuDesktopSubMenuWrapper from './sub-menu/sub-menu-wrapper';
import { linkToClass } from '../../domain/top-menu-desktop-provider';
import TopMenuAskWavesBtn from '../../../ask-waves/top-menu-ask-waves-btn';

interface ITopMenuDesktopProps {
    data: ITopMenuDesktop;
}

const TopMenuDesktop = ({ data }: ITopMenuDesktopProps) => {

    return (
        <div className={`waves-top-menu-box text-tiny items-center xl:flex flex-1`}>

            <TopMenuDesktopBeforeItem data={ data } />

            <ul className="waves-top-menu hidden xl:flex flex-1 text-tiny items-center relative h-full">
                {
                    data.topMenu.map((item, i) => {

                        const hasSubMenu = item.subMenu && item.subMenu.length > 0;

                        return (
                            <li key={ `${ item.text }-${ item.link }-${ i }` } className={ `relative h-full flex items-center ${ linkToClass(item.link) } ${ hasSubMenu ? 'has-drop-down' : '' }` }>
                                <a
                                    className="flex items-center py-3 pl-3 pr-6 relative text-white no-underline"
                                    href={ item.link }
                                    data-gaevent="Top Menu"
                                    data-gavalue={ item.text }>
                                    <span>{ item.text }</span>
                                </a>

                                {
                                    hasSubMenu &&
                                    <TopMenuDesktopSubMenuWrapper item={ item } />
                                }
                            </li>
                        )
                    })
                }

                <li>
                    <TopMenuAskWavesBtn classes="ask-waves__desktop"  />
                </li>
            </ul>
        </div>
    )
};

export default TopMenuDesktop;